import { AuthUserService } from './services/authusers.service';
export const authSettingsState: aboTheme.IState = {

    parent: "app",
    name: "authsettings",
    url: "/authsettings",
    //redirectTo: "authsettings.list",
    component: "authSettingsComponent",
    data: {
        permissions: {
            only: ['SUPERUSER'],
            redirectTo: 'schedule'
        }
    }

};

export const authSettingsUsersState: aboTheme.IState = {

    name: "authsettings.users",
    url: "/users",
    resolve: {
        authUsers: (AuthUserService: AuthUserService) => { 'ngInject'; return AuthUserService.all(); }
    },
    views: {
        "main": 'authSettingsUsersComponent'
    }    

};

export const authSettingsUsersItemState: aboTheme.IState = {

    name: "authsettings.users.item",
    url: "/:id",
    resolve: {
        authUser: (AuthUserService: AuthUserService, $stateParams: ng.ui.IStateParamsService) => {
            'ngInject';
            if ($stateParams['id'] != 0) {
                return AuthUserService.get($stateParams['id']);
            }
        }
    },
    views: {
        "main@authsettings": 'authSettingsUsersItemComponent'
    }
};

export const authSettingsServerState: aboTheme.IState = {

    name: "authsettings.server",
    url: "/server",
    //redirectTo: "authsettings.list",
    views: {
        "main": 'authSettingsServerComponent'
    }

};






// WEBPACK FOOTER //
// ./src/app/authsettings/authsettings.states.ts